import React, { useRef } from 'react';
import cx from 'classnames';
import { debounce } from 'lodash';
import { Col, Row } from 'react-bootstrap';

import FieldInput from '@magoosh/lib/formik_inputs/field_input';

import style from '@payments/style.module.scss';

interface Props {
  onZipCodeChanged?: (zipCode: string) => void;
}

// Sales tax depends on where the card is billed, so a form that prices a purchase collects this
// alongside the card itself. A form that only stores a card has nothing to price and leaves it out.
const BillingZipCode: React.FC<Props> = (props) => {
  const debouncedHandleZipCodeChanged = useRef(
    debounce((zipCode) => {
      props.onZipCodeChanged && props.onZipCodeChanged(zipCode);
    }, 500)
  ).current;

  return (
    <Row>
      <Col md={6}>
        <FieldInput
          onKeyUp={(e) => debouncedHandleZipCodeChanged(e.target.value)}
          name="zipCode"
          type="input"
          label="Billing ZIP"
          hint="Or Postal Code if you're not in the USA"
          className={cx(style.mediumStringInput, style.fullWidthOnMobile)}
        />
      </Col>
    </Row>
  );
};

export default BillingZipCode;
